import React, { useContext, useState } from 'react';
import { Grid } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import City2CityIcon from '../../assets/images/city2city_logo.png';
// import City2CityIcon from '../../assets/images/logo512.png';
import CustomizerContext from '../../_helper/Customizer';

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, layout, layoutURL } = useContext(CustomizerContext);
  const [toggle, setToggle] = useState(false);

  const openCloseSidebar = () => {
    setToggle(!toggle);
    toggleSidebar(toggle);
  };

  const layout1 = localStorage.getItem('sidebar_layout') || layout;

  return (
    <div className='logo-wrapper' style={{ padding: "8px 0 0 20px" }}>
      {layout1 !== 'compact-wrapper dark-sidebar' && layout1 !== 'compact-wrapper color-sidebar' && mixLayout ? (
        <Link to="/">
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${City2CityIcon}`, alt: '', style: { width: '100px', height: 'auto' } }} />
        </Link>
      ) : (
        <Link to="/">
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${City2CityIcon}`, alt: '', style: { width: '100px', height: 'auto' } }} />
        </Link>
      )}
      <div className='back-btn' onClick={() => openCloseSidebar()}>
        <i className='fa fa-angle-left'></i>
      </div>
      <div className='toggle-sidebar' onClick={openCloseSidebar}>
        <Grid className='status_toggle middle sidebar-toggle' />
      </div>
    </div>
  );
};

export default SidebarLogo;
